// removed by extract-text-webpack-plugin
module.exports = {"colored-background":"colored-background___jFq5I","coloredBackground":"colored-background___jFq5I","date-picker":"date-picker___bRTYk","datePicker":"date-picker___bRTYk"};